import {
    StyledApplyDataAgreementsText,
    StyledFinalStepModalBtnWrapper,
    StyledFinalStepModalDescription,
    StyledFinalStepModalTitle,
    StyledIconWrapper,
    StyledIntentModalLinkWrapper,
    StyledModalFinalStep,
} from "./styles";
import { Button } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { SWReactIcons } from "@similarweb/icons";
import type { ReactElement } from "react";
import {
    StyledIntentTopicsViewLink,
    StyledIntroViewIcon,
} from "app/pages/sales-intelligence/pages/manage-signals/components/IntroductionView/styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

type ModalContentFinalStepProps = {
    onApply: () => void;
};

const ApplyDataAgreementsContent = ({ onApply }: ModalContentFinalStepProps): ReactElement => {
    return (
        <StyledModalFinalStep>
            <StyledIconWrapper>
                <SWReactIcons
                    iconName="fire-colored"
                    size={"xxl"}
                />
            </StyledIconWrapper>
            <I18n
                data-automation="general-info-title-text"
                element={StyledFinalStepModalTitle}
                translatable={{ key: "si.intent.management.modal.dataAgreements.title" }}
            />
            <I18n
                data-automation="general-info-title-text"
                element={StyledApplyDataAgreementsText}
                translatable={{ key: "si.intent.management.modal.dataAgreements.description" }}
            />
            <StyledFinalStepModalDescription
                dangerouslySetInnerHTML={{
                    __html: translate("si.intent.management.modal.dataAgreements.agreementText"),
                }}
            />
            <StyledFinalStepModalBtnWrapper>
                <Button
                    type="primary"
                    onClick={onApply}
                >
                    {translate("si.intent.management.modal.btn.success-save-topic")}
                </Button>
            </StyledFinalStepModalBtnWrapper>

            <StyledIntentModalLinkWrapper>
                <StyledIntentTopicsViewLink
                    href={"https://support.similarweb.com/hc/en-us/articles/14234221556509"}
                    target={"_blank"}
                >
                    {translate("si.signals.traffic-changes.learnMore")}
                    <StyledIntroViewIcon
                        iconName="link-out"
                        size="xs"
                    />
                </StyledIntentTopicsViewLink>
            </StyledIntentModalLinkWrapper>
        </StyledModalFinalStep>
    );
}

export default ApplyDataAgreementsContent;
